import { ProviderModule } from "./../providers/provider.module";
import { RepositoryModule } from "./../repositories/repository.module";
import { HttpClientModule } from "@angular/common/http";
import { ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { StoreDevtoolsModule } from "@ngrx/store-devtools";

import { IonicStorageModule } from "@ionic/storage";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";

import { MyApp } from "./app.component";
import { AppStateModule } from "../states/app-state.module";
import { DatabaseHelper } from "../services/databaseHelper.service";
import { EnvServiceProvider } from "../environments/environment.factory";
import { Helper } from "../services/helper.service";
import { SmartProvider } from '../providers/smart/smart';
import { ImageResizer } from "../services/imageResizer.service";
import { LaddaModule } from "angular2-ladda";

export const config = {
  platform: "md"
};

const env: { production: boolean, model: string, api: string } = (<any>window).__env;

@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp, config),
    IonicStorageModule.forRoot(),
    AppStateModule,
    RepositoryModule,
    ProviderModule,
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: env ? !env.production : true
    }),
    LaddaModule.forRoot({
      style: 'zoom-in'
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    EnvServiceProvider,
    DatabaseHelper,
    Helper,
    ImageResizer,
    // Keep this to enable Ionic's runtime error handling during development
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    SmartProvider,
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts